import StandsGlobalMaterialsField from "./stands-global-materials-field";

const StandsGlobalFields = {
    Materials: StandsGlobalMaterialsField,
}

export default StandsGlobalFields;
